import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";

export const renderTeamsScore = (score1: string, score2: string) =>
    //to-do: scoreboards
    <>
        <EventCardSectionItem content={score1} className="rj-ev-list__ev-card__score rj-ev-list__ev-card__score-home" />
        <EventCardSectionItem content={score2} className="rj-ev-list__ev-card__score rj-ev-list__ev-card__score-away" />
    </>